<h1>Tack för din ansökan</h1>
<b *ngIf="dnr"> Din ansökan har tilldelats ärendenummer {{dnr}}.</b>
<p>Ansökan kommer bedömas efter de uppgifter du har lämnat i formulär och bifogade dokument.</p>

<label class="text-standard" for="email-desc">Om bekräftelsen</label>
<div id="email-desc">
    <p>
        Skolverket skickar en bekräftelse på att vi har registrerat din ansökan. Bekräftelsen kommer att skickas till 
        din digitala brevlåda (till exempel KIVRA eller Min myndighetspost), om du har en sådan. Annars kommer 
        bekräftelsen istället via post till din folkbokförda adress. 
        Bekräftelsen innehåller: 
    </p>
    <ul>
        <li>
            Ditt ärendenummer<ng-container *ngIf="dnr">: {{dnr}}</ng-container>
        </li>
        <li>Ditt försättsblad</li>
        <li>Eventuell betalinformation</li>
    </ul>
    <p>
        Om du inte fått bekräftelsen till din digitala brevlåda inom 2 arbetsdagar eller via post inom 4 arbetsdagar kan du 
        kontakta oss. 
    </p>
</div>
<app-reveal title="Om försättsbladet">
    <label class="text-standard" for="cover-page">Om försättsbladet</label>
    <p id="cover-page">
        När du postar bilagor till Skolverket behöver du bifoga ett försättsblad som innehåller ditt personnummer
        och
        ärendenummer. Försättsbladet gör att vi automatiskt kan skanna bilagorna och koppla dem till ditt ärende. Du
        får
        försättsbladet som en PDF-fil i ditt bekräftelsemejl. Vänligen häfta inte ihop dina papper eftersom det
        försvårar
        skanningen.
    </p>
</app-reveal>

<app-reveal title="Så hanterar Skolverket din ansökan">
    <label class="text-standard" for="handling-desc">Så hanterar Skolverket din ansökan</label>
    <div id="handling-desc">
        <p>
            Handläggningen av ditt ärende påbörjas när alla bilagor är inskickade till Skolverket.
            Om det är något som saknas i din ansökan kontaktar vi dig angående vilka uppgifter du behöver
            komplettera
            med.
        </p>
        <p>
            Alla ansökningar om legitimation handläggs i den ordning de kommer in.
            Handläggningstiden kan variera något beroende på vilken typ av examen du har och vilka behörigheter du
            har
            ansökt om.
        </p>
        <app-link href="http://www.skolverket.se/leghandlaggning" external="true">
            Läs mer om hur Skolverket hanterar din ansökan
        </app-link>
    </div>
</app-reveal>

<app-reveal
    title="Jag missade att skriva att jag vill ha behörighet i ett ämne, kan jag komplettera ett pågående ärende?">
    <label class="text-standard" for="supplement-desc">Jag missade att skriva att jag vill ha behörighet i ett ämne,
        kan jag komplettera ett pågående ärende?</label>
    <p>
        Ja, det är möjligt att komplettera ett pågående ärende med fler handlingar.
        <br />
        Om du vill komplettera ditt pågående ärende med kursintyg eller erfarenhetsintyg ska du också tala om vilken
        ytterligare behörighet du vill ha och grunden för det. Du ska då ange
    </p>
    <ul>
        <li>skolform</li>
        <li>ämne/ämnesområde</li>
        <li>årskurser (för de skolformer där det är aktuellt)</li>
        <li>om du ansöker utifrån studier, erfarenhet eller någon annan grund.</li>
    </ul>
    <p>
        Om du skickar in din komplettering med e-post kan du skriva uppgifterna ovan direkt i e-postmeddelandet.
        Ange även ditt ärende- eller personnummer.
        <br />
        Epost till <a href="mailTo:legkomplettering@skolverket.se">legkomplettering&#64;skolverket.se</a>
    </p>
</app-reveal>